import StudentEnquiryForm from '../commonfile/StudentEnquiryForm'

const ZoneManagerEnquiryList = () => {
    return (
        <>
            <StudentEnquiryForm />
        </>
    )
}

export default ZoneManagerEnquiryList